import { z } from 'zod';

import { idSchema, isoDateSchema, jsonMetaSchema } from './common.schema';

export const savedViewScopeSchema = z.enum(['system', 'workspace', 'personal']);

export const savedViewSchema = z.object({
  id: idSchema,
  workspace_id: idSchema.nullable().optional(),
  owner_id: idSchema.nullable().optional(),
  scope: savedViewScopeSchema,
  name: z.string(),
  icon: z.string().nullable().optional(),
  filters: jsonMetaSchema,
  sort: z.array(z.unknown()).default([]),
  pinned: z.boolean(),
  created_at: isoDateSchema,
  updated_at: isoDateSchema,
});
export type SavedView = z.infer<typeof savedViewSchema>;

export const createSavedViewSchema = z.object({
  name: z.string().min(1).max(200),
  icon: z.string().max(32).optional(),
  scope: savedViewScopeSchema.default('personal'),
  filters: jsonMetaSchema,
  sort: z.array(z.unknown()).optional(),
  pinned: z.boolean().optional(),
});

export const updateSavedViewSchema = createSavedViewSchema.partial();
